import {Routes} from "@angular/router";
import {ProjectViewPurchasesComponent} from "./project-view-purchases/project-view-purchases.component";
import {ProjectViewInfoComponent} from "./project-view-info/project-view-info.component";
import {ProjectEditComponent} from '../project-edit/project-edit.component';
import {routerHandler} from "../../../resources/utils/router";

export const ProjectViewRoutesData = {
  'redirect': routerHandler.redirect('project'),
  'info': routerHandler.info('project', {component: ProjectViewInfoComponent}),
  'purchases': routerHandler.purchases('project', {component: ProjectViewPurchasesComponent}),
  'edit': routerHandler.edit('project', {component: ProjectEditComponent}),
};

export const ProjectViewRoutes: Routes = Object.values(ProjectViewRoutesData);
